import type { ColumnType, Generated, Selectable } from 'kysely'
import z from 'zod'

import { nanoidSchema } from '@/utility'

export type AgentKeyEntity = {
  id: Generated<string>
  teamUid: string
  name: string
  description: string
  revoked: boolean
  expiresAt: ColumnType<string, Date, Date>
  createdAt: ColumnType<string, never, never>
  updatedAt: ColumnType<string, never, never>
}

export type AgentKey = Selectable<AgentKeyEntity>

export const agentKeySchema = z
  .object({
    id: z.string(),
    teamUid: z.string(),
    name: z.string().max(50).default('My Agent Key'),
    description: z.string().max(200).default(''),
    revoked: z.boolean(),
    expiresAt: z.string(),
    createdAt: z.string(),
    updatedAt: z.string(),
  })
  .meta({ id: 'agent-key' }) satisfies z.ZodType<AgentKey>

export const agentTokenPayloadSchema = z
  .object({
    uid: z.string(),
    teamUid: nanoidSchema,
    exp: z.number().int(),
  })
  .meta({ id: 'agent-token-payload' })

export type AgentTokenPayload = z.infer<typeof agentTokenPayloadSchema>

export const SCALAR_AGENT_KEY_HEADER = 'x-scalar-agent-key'
